import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit, computed, inject, signal } from '@angular/core';
import { Subject, map } from 'rxjs';
import {
  Cuenta,
  NotificacionPlaceToPay,
  RecargaPlaceToPay,
  SuscripcionPlaceToPay,
  VehiculoInterface,
} from 'src/app/core/models/global.model';

import { GuardService } from 'src/app/core/services/guards.service';
import { globalConfig } from 'src/app/core/utils/globalConfig';

export const RECARGA_AUTOMATICA_DRAFT_KEY = 'recarga_automatica_draft';
export const RECARGA_AUTOMATICA_LINK_PENDING_KEY = 'recarga_automatica_link_pending';

@Injectable({
  providedIn: 'root',
})
export class FormasPagoService implements OnInit {
  isPlaceToPayScriptCharged: boolean = false;
  activeStep: number = 0;
  formaPagoSeleccionada!: string;
  ipAddress!: string;

  guardService = inject(GuardService);

  http = inject(HttpClient);

  #stateVehiculo = signal<any>({
    vehiculos: [],
    paginacion: {},
  });

  #stateMedioPago = signal<any>({
    medioPago: [],
    loading: true,
  });

  public datosVehiculos = computed(() => this.#stateVehiculo());
  public stateMedioPago = computed(() => this.#stateMedioPago());
  public medioPago = computed(() => this.#stateMedioPago().medioPago);

  constructor() {}

  // Creamos un Subject para emitir eventos
  public functionExecution$: Subject<void> = new Subject<void>();
  public paymentSetupResult$ = new Subject<'link-success' | 'link-error'>();

  // Método para ejecutar la función
  executeFunction(): void {
    this.functionExecution$.next();
  }

  ngOnInit(): void {}

  realizarRecarga(recargaPlaceToPay: RecargaPlaceToPay) {
    return this.http.post('/place-to-pay/recarga', recargaPlaceToPay);
  }

  realizarSuscripcion(suscripcionPlaceToPay: SuscripcionPlaceToPay) {
    return this.http.post('/place-to-pay/suscripcion', suscripcionPlaceToPay);
  }

  realizarNotificacion(notificacionPlaceToPay: NotificacionPlaceToPay) {
    return this.http.post(`${globalConfig.apiUrlBackTolis}/place-to-pay/notificacion`, notificacionPlaceToPay, {
      headers: {
        'Skip-Interceptor': '',
      },
    });
  }

  desvincularTarjeta(idCuenta: string) {
    return this.http.delete(`/place-to-pay/desvinculacion/${idCuenta}`);
  }

  cambiarTipoPago(idCuenta: string, cuenta: Cuenta) {
    return this.http.patch(`/place-to-pay/cambiar-tipo-pago-cuenta/${idCuenta}`, cuenta);
  }

  configurarRecargaAutomatica(configuracion: { montoRecarga: number; saldoMinimo: number }) {
    return this.http.patch('/recarga-automatica/configuracion', configuracion);
  }

  cambiarPrimerInicioAFalse() {
    return this.http.patch(`/usuario-front/change-primer-inicio`, {});
  }

  getMedioPagoByCuentaId() {
    this.#stateMedioPago.update((state: any) => ({
      ...state,
      loading: true,
    }));

    return this.http
      .get('/medio-pago/by-cuenta-id')
      .pipe(
        map(({ data }: any) => {
          return data;
        }),
      )
      .subscribe({
        next: (medioPago: any) => {
          this.#stateMedioPago.set({
            medioPago,
            loading: false,
          });
        },
        error: () => {
          this.#stateMedioPago.update((state: any) => ({
            ...state,
            loading: false,
          }));
        },
      });
  }

  async getIpAddress() {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      this.ipAddress = data.ip;
    } catch (error) {
      console.log({ ipify: error });
    }
  }
}
